import {useQuery} from "@tanstack/react-query";
import {readCurrencyTypeSelectBox} from "../../../../../api/order/OrdersApi";

export const useReadCurrencyTypeSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readCurrencyTypeSelectBox"],
        queryFn: async () => await readCurrencyTypeSelectBox(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
